const opportunitiesLang = {

}

export default {
  opportunities: opportunitiesLang
}
